import React, { useState } from "react";
// import DynamicPages from "./dynamic-pages.json";
import "../../styles/branch-io/dynamic-linking.css";
import DynamicPagesForm from "./DynamicPagesForm";

const DLLists = ({ userInfoData, DynamicPages }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleSidebarToggle = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <div className="dl-container">
        <button className="mobile-menu-btn" onClick={handleSidebarToggle}>
          ☰ Menu
        </button>

        <div className={`dl-sidebar ${menuOpen ? "open" : ""}`}>
          {DynamicPages.map((page, index) => (
            <div
              key={index}
              className={`dl-sidebar-item ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => {
                setActiveIndex(index);
                setMenuOpen(false);
              }}>
              {page?.screen_label || ""}
            </div>
          ))}
        </div>

        <div className="dl-content">
          <h2>{DynamicPages?.[activeIndex]?.screen_label || ""}</h2>
          <p>
            Create Dynamic Link for{" "}
            {DynamicPages?.[activeIndex]?.screen_label || ""}
          </p>

          <DynamicPagesForm
            key={activeIndex}
            userInfoData={userInfoData}
            dynamicPageInfo={DynamicPages[activeIndex]}
          />
        </div>

        {menuOpen && (
          <div className="overlay" onClick={() => setMenuOpen(false)} />
        )}
      </div>
    </>
  );
};

export default DLLists;
